export const workflowsApiPaths = <const>{
    workflows: 'companies/:companyId/workflows',
    workflowsReviewerV1: 'companies/:companyId/workflows/reviewerV1',
};
